import { useQuery } from 'react-query';

import { getAiAlertSubscriptions } from '@utils/backend-api/aiAlertSubscriptions';

export const AI_ALERT_SUBSCRIPTIONS_KEY = 'AI_ALERT_SUBSCRIPTIONS';

interface UseAiAlertSubscriptionsParams {
  aiThreadId?: string;
  includeUnsubscribed?: boolean;
  disable?: boolean;
}

export default function useAiAlertSubscriptions({
  aiThreadId,
  includeUnsubscribed = false,
  disable = false,
}: UseAiAlertSubscriptionsParams = {}) {
  const { data, isLoading } = useQuery(
    [AI_ALERT_SUBSCRIPTIONS_KEY, aiThreadId, includeUnsubscribed],
    async () =>
      await getAiAlertSubscriptions({
        includeUnsubscribed,
        aiThreadId,
      }),
    {
      enabled: !disable,
    }
  );

  return {
    aiAlertSubscriptions: data?.aiAlertSubscriptions,
    isLoadingAiAlertSubscriptions: isLoading,
  };
}
